/**
 * @author Nihar <nihar.baishya@314ecorp.com>
 * @description Export button for eligibility batch template
 */

import { Button } from 'antd';
import { Download } from '@icon-park/react';

import useExportEligibilityBatchTemplate from 'hooks/eligibility/mutate/useExportEligibilityBatchTemplate';
import EventTracker from 'utils/eventTracker';
import { EVENTS } from 'app-constants/events';

/**
 * ExportEligibilityBatchTemplate button
 */

const ExportEligibilityBatchTemplate: React.FC = () => {
	const { mutate } = useExportEligibilityBatchTemplate();

	const exportTemplate = () => {
		mutate(undefined);
		EventTracker.trackEvent(EVENTS.eligibilityBatchUpload.exportBatchTemplate());
	};

	return (
		<Button
			data-testid='batch-download-template-button'
			type='default'
			onClick={exportTemplate}
			icon={<Download />}
			iconPosition='start'
			className='export-eligibility-batch-template-button'
		>
			{'Download Batch Template'}
		</Button>
	);
};

export default ExportEligibilityBatchTemplate;
